import { DIMENSION_COLOR } from './JourneyLines';

export const TierBadgeInline = ({ tier, membershipType }) => {
  const label = membershipType === 'free_comp' ? 'VIP' : (tier || 'bronze');
  return (
    <span
      className="inline-flex items-center rounded-full border border-amber-300/40 bg-amber-300/10
                 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-amber-200"
      data-testid="companion-tier-badge"
    >
      {label}
    </span>
  );
};

/** Where they are in the program. Estimated completion comes from their own pace. */
export const CoachingStatus = ({ coaching, compact = false }) => {
  if (!coaching) return null;
  const est = coaching.estimated_completion
    ? new Date(coaching.estimated_completion).toLocaleDateString(undefined,
      { month: 'long', year: 'numeric' })
    : null;

  return (
    <section data-testid="coaching-status">
      <h3 className="text-xs uppercase tracking-wider text-white/40 mb-2">Coaching journey</h3>
      <div className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
        <div className="flex items-baseline justify-between gap-3 mb-3">
          <span className="text-sm text-white/90">
            {coaching.finished ? 'Program complete'
              : coaching.current_module?.title || 'Not started'}
          </span>
          <span className="text-xs text-white/40">
            {coaching.modules_completed} of {coaching.modules_total} complete
          </span>
        </div>
        <div className="h-1.5 w-full rounded-full bg-white/10 overflow-hidden">
          <div
            className="h-full rounded-full bg-gradient-to-r from-cyan-400 to-violet-400
                       transition-all duration-700"
            style={{ width: `${coaching.percent_complete}%` }}
            data-testid="coaching-progress-bar"
          />
        </div>
        <div className="mt-3 grid grid-cols-2 gap-3 text-xs">
          {coaching.next_module && (
            <div>
              <div className="text-white/40">Next</div>
              <div className="text-white/80">{coaching.next_module.title}</div>
            </div>
          )}
          <div>
            <div className="text-white/40">Estimated completion</div>
            <div className="text-white/80" data-testid="coaching-estimated-completion">
              {est || 'Needs a couple of modules to estimate'}
            </div>
          </div>
        </div>
        {!compact && coaching.average_days_per_module && (
          <p className="text-[11px] text-white/30 mt-3">
            Based on your own pace so far — about {coaching.average_days_per_module} days a module.
            It moves with you.
          </p>
        )}
      </div>
    </section>
  );
};

/** Movement-first. Only dimensions this assessment and the previous one both measured. */
export const MovementList = ({ movements = [], testid = 'movement-list' }) => {
  const moved = movements.filter((m) => m.since_last);
  if (moved.length === 0) {
    return (
      <p className="text-xs text-white/40" data-testid={`${testid}-empty`}>
        No dimension has a previous reading to compare with yet.
      </p>
    );
  }
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {moved.map((m) => {
        const up = m.since_last.change > 0;
        const flat = m.since_last.change === 0;
        return (
          <span
            key={m.dimension}
            className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs"
            style={{ borderColor: `${DIMENSION_COLOR[m.dimension]}55` }}
            data-testid={`movement-${m.dimension}`}
          >
            <span className="text-white/70">{m.dimension_name}</span>
            <span className={flat ? 'text-white/40' : up ? 'text-emerald-300' : 'text-amber-300'}>
              {up ? '+' : ''}{m.since_last.change}
            </span>
            <span className="text-white/30">since {m.since_last.from_short_label}</span>
          </span>
        );
      })}
    </div>
  );
};
